import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × MERCI PARIS: Everyday ethics as design
// Store grid layout, paper collage, community typography
export function VasarelyMerciMode({ brand }: ModeRendererProps) {
  return (
    <g>
      <defs>
        <linearGradient id="merci-paper1" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#F5F5DC" />
          <stop offset="100%" stopColor="#E8E8D0" />
        </linearGradient>
        <linearGradient id="merci-paper2" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#FFE4B5" />
          <stop offset="100%" stopColor="#F5DEB3" />
        </linearGradient>
        <pattern id="merci-texture" x="0" y="0" width="40" height="40" patternUnits="userSpaceOnUse">
          <line x1="0" y1="0" x2="40" y2="40" stroke="#D3D3C0" strokeWidth="0.5" opacity="0.3" />
          <line x1="40" y1="0" x2="0" y2="40" stroke="#D3D3C0" strokeWidth="0.5" opacity="0.3" />
        </pattern>
      </defs>

      {/* Paper beige background */}
      <rect x="0" y="0" width="794" height="1123" fill="url(#merci-paper1)" />
      <rect x="0" y="0" width="794" height="1123" fill="url(#merci-texture)" />

      <g transform="translate(397 540)">
        {/* Store grid layout */}
        {Array.from({ length: 10 }).map((_, i) =>
          Array.from({ length: 14 }).map((_, j) => {
            const x = (i - 4.5) * 70;
            const y = (j - 6.5) * 75;
            
            return (
              <rect
                key={`${i}-${j}`}
                x={x - 33}
                y={y - 35}
                width="66"
                height="70"
                fill="none"
                stroke="#C8B896"
                strokeWidth="1"
                opacity="0.3"
              />
            );
          })
        )}

        {/* Paper collage layers */}
        {[
          { x: -220, y: -280, w: 180, h: 240, rot: 2, fill: "url(#merci-paper1)" },
          { x: 20, y: -250, w: 200, h: 220, rot: -3, fill: "url(#merci-paper2)" },
          { x: -200, y: -20, w: 190, h: 250, rot: 1, fill: "#FFF8DC" },
          { x: 30, y: 10, w: 180, h: 230, rot: -2, fill: "url(#merci-paper1)" },
        ].map((collage, i) => (
          <rect
            key={i}
            x={collage.x}
            y={collage.y}
            width={collage.w}
            height={collage.h}
            fill={collage.fill}
            stroke="#C8B896"
            strokeWidth="2"
            opacity="0.4"
            transform={`rotate(${collage.rot} ${collage.x + collage.w / 2} ${collage.y + collage.h / 2})`}
          />
        ))}

        {/* Community typography */}
        {[
          { text: "MERCI", x: 0, y: -180, size: 60 },
          { text: "PARIS", x: 0, y: -120, size: 40 },
          { text: "CONCEPT", x: 0, y: 20, size: 35 },
          { text: "STORE", x: 0, y: 60, size: 35 },
        ].map((label, i) => (
          <text
            key={i}
            x={label.x}
            y={label.y}
            fontFamily="sans-serif"
            fontSize={label.size}
            fill="#8B7355"
            opacity="0.3"
            textAnchor="middle"
            fontWeight="300"
            letterSpacing="5"
          >
            {label.text}
          </text>
        ))}

        {/* Civic modernity circles */}
        {Array.from({ length: 10 }).map((_, i) => {
          const r = 60 + i * 30;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke="#C8B896"
              strokeWidth="1"
              opacity={0.25 - i * 0.02}
            />
          );
        })}

        {/* Optical compassion grid */}
        <rect x="-150" y="-150" width="300" height="300" fill="none" stroke="#8B7355" strokeWidth="2" opacity="0.4" />
        <rect x="-140" y="-140" width="280" height="280" fill="none" stroke="#C8B896" strokeWidth="1" opacity="0.3" />

        {/* Central heart (community) */}
        <path
          d="M 0,-40 C -50,-90 -100,-60 -100,0 C -100,50 0,100 0,100 C 0,100 100,50 100,0 C 100,-60 50,-90 0,-40 Z"
          fill="#D2691E"
          opacity="0.15"
        />
        <path
          d="M 0,-30 C -37.5,-67.5 -75,-45 -75,0 C -75,37.5 0,75 0,75 C 0,75 75,37.5 75,0 C 75,-45 37.5,-67.5 0,-30 Z"
          fill="none"
          stroke="#8B7355"
          strokeWidth="2"
          opacity="0.4"
        />
      </g>

      {/* Civic modernity */}
      <text x="397" y="1010" textAnchor="middle" fontFamily="sans-serif" fontSize="10" fill="#8B7355" letterSpacing="3">
        modernité civique
      </text>
    </g>
  );
}
